<template>
  <div class="container sticky-top w-75 text-center">
    <div class="mb-4 pt-2 price-container rounded border border-dark-subtle">
      <label for="totalPriceTracker" class="text-white">Éves díj</label>
      <input
        v-if="merchant_id !== default_id || totalPrice === 0"
        type="text"
        readonly
        :value="totalPrice | currency"
        class="text-white text-center form-control price-input"
        id="totalPriceTracker"
      />
      <div
        v-else
        id="totalPriceTracker"
        class="text-white text-center form-control price-input"
      >
        <span class="fs-5 mx-1">{{
          (totalPrice * (1 - maxDiscount / 100)) | currency
        }}</span
        >-tól
        <button
          class="info"
          id="kedvezmenyes_evesdij-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          data-tooltip="kedvezmenyes_evesdij"
          title=""
          type="button"
        >
          ?
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  created() {
    this.$store.dispatch("getMarks");
  },
  computed: {
    ...mapFields([
      "chosenPackage",
      "chosenAccessories",
      "packagePrices",
      "valaszthatoKiegeszitok",
      "merchant_id",
      "maxDiscount",
    ]),
    totalPrice: function() {
      if (!this.chosenPackage) {
        return 0;
      }

      let sum = this.packagePrices[this.chosenPackage];

      Object.keys(this.chosenAccessories).forEach((a) => {
        if (this.chosenAccessories[a].selected) {
          if (this.chosenAccessories[a].limit) {
            sum +=
              this.valaszthatoKiegeszitok[this.chosenPackage][a]?.dij *
                this.chosenAccessories[a].limit || 0;
          } else if (this.chosenAccessories[a].tovabbi_adatok) {
            let sumOfValues = Object.values(
              this.chosenAccessories[a].tovabbi_adatok,
            ).reduce((acc, cv) => {
              if (typeof cv === "number") {
                return acc + cv;
              } else {
                return acc + Number(cv.split(/\s+/).join(""));
              }
            }, 0);
            sum +=
              (this.valaszthatoKiegeszitok[this.chosenPackage][a]?.percent /
                1000) *
              sumOfValues;
          } else {
            sum += this.valaszthatoKiegeszitok[this.chosenPackage][a]?.dij || 0;
          }
        }
      });
      return sum;
    },
  },
};
</script>

<style>
.price-container {
  background-color: #666 !important;
  /* opacity: 90% !important; */
}

.price-input {
  background-color: #99999900 !important;
  border: none !important;
  opacity: 100% !important;
}
</style>
